import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorLogger } from '@byscott-io/issuesbyscott_client';
import { configure as configureMetrics } from '@byscott-io/metricsbyscott-web';
import { storage, configureAuth } from '@byscott-io/corebyscott';
import App from './App';

// Set up client-side error reporting
if (window.ENV?.ISSUESBYSCOTT_API_URL && window.ENV?.ISSUESBYSCOTT_API_KEY) {
  ErrorLogger.configure({
    apiUrl: window.ENV.ISSUESBYSCOTT_API_URL,
    apiKey: window.ENV.ISSUESBYSCOTT_API_KEY,
    environment: window.ENV.RAILS_ENV || 'production',
    enabled: window.ENV.RAILS_ENV === 'production',
  });
  ErrorLogger.setupGlobalHandler();

  // setupGlobalHandler catches window.onerror, which React render errors do NOT
  // reach -- React swallows them and unmounts the tree. Core's ErrorBoundary is
  // what sees those, and it reports through core's own config, so point it here.
  // It also carries the component stack, which window.onerror cannot know.
  configureAuth({
    onError: (error, info) =>
      ErrorLogger.report(error, { componentStack: info?.componentStack }),
  });
}

// Set up metrics tracking (page views + visitor/attribution). Without this
// configure() call the imported usePageTracking hook has no client and never
// fires — recipes previously emitted zero page_views for this reason.
if (window.ENV?.METRICSBYSCOTT_API_URL && window.ENV?.METRICSBYSCOTT_API_KEY) {
  configureMetrics({
    apiUrl: window.ENV.METRICSBYSCOTT_API_URL,
    apiKey: window.ENV.METRICSBYSCOTT_API_KEY,
    appName: 'recipesbyscott',
    autoClickTrackingAnonymous: true,
    enabled: window.ENV.RAILS_ENV === 'production',
    // Seed identity synchronously from cached auth so a logged-in user's first
    // page_view is attributed without waiting for /me.
    userId: storage.getCurrentUserId() || undefined,
    containerId: storage.getCurrentContainerId() || undefined,
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root');
  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  }
});
